module.exports = __webpack_public_path__ + "static/browse2-5cc4afa2d15bf7c9aeb79fde1f053d56.png";